module.exports = __webpack_public_path__ + "img/yl3041.25ef5362.png";